import React, { useEffect } from 'react';
import { useDispatch, useSelector, shallowEqual } from "react-redux";
import * as actionsLocalidad from "./_redux/localidadActions";
import Select from 'react-select';

const SelectorLocalidad = (props) => {
    const { localidadesChild, setLocalidadChild, localidadChild, soloConOfertas } = props;
    const { localidad } = useSelector(
        (state) => ({ localidad: state.localidad }),
        shallowEqual
    );

    const {
        entities,
        listLoading,
        error
    } = localidad;

    const dispatch = useDispatch();

    useEffect(() => {
        if (!listLoading && !entities && !error) {
            dispatch(actionsLocalidad.fetchLocalidades({ soloConOfertas }));
        }
    }, []);

    return (
        <Select
            //className="form-control"
            classNamePrefix="select"
            //defaultValue={localidadesChild[0]}
            value={localidadChild}
            //isDisabled={false}
            isLoading={listLoading}
            isRtl={false}
            isSearchable={true}
            name="color"
            isDisabled={!localidadesChild || localidadesChild.length === 0}
            options={localidadesChild}
            getOptionValue={({ localidadId }) => localidadId}
            getOptionLabel={({ localidadNombre }) => `${localidadNombre}`}
            noOptionsMessage={() => 'Sin Localidades'}
            placeholder={!localidadesChild || localidadesChild.length === 0 ? "Sin Localidades" : "Filtrar por Localidad"}
            onChange={(item) => {
                setLocalidadChild(item);
            }}
        />
    )
}

export default SelectorLocalidad;